import React from "react";
import talkexpertIcon from "asset/image/talkexpertIcon.png";
import locationIcon from "asset/image/locationIcon.png";
import catalogueIcon from "asset/image/catalogueIcon.png";
import messageIcon from "asset/image/messageIcon.png";
import "./CustomerService.css";
import {
  StyledBordediv,
  StyledHeadingdiv,
} from "container/HomePage/Homepage.styles";
import { LazyLoadComponent } from "react-lazy-load-image-component";

const CustomerService = () => {
  return (
    <LazyLoadComponent>
      <section className="customer-service-section">
        <div className="container">
          <div className="main-heading para-padd">
            <h2>Get in Touch</h2>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="row justify-content">
                <div className="col-sm-3">
                  <div className="footer-information">
                    <img
                      width="28"
                      height="34"
                      src={locationIcon}
                      alt="Dealer Locator"
                      sizes="(max-width: 28px) 100vw, 28px"
                    />

                    <a
                      href="/locate/dealer"
                      id="footerDealerLocator"
                      className="footerdealerlocator text-link"
                    >
                      Dealer Locator
                    </a>
                    <p>
                      Find the closest Johnson Bathrooms dealer location and
                      contact information
                    </p>
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="footer-information">
                    <img
                      width="28"
                      height="28"
                      src={messageIcon}
                      alt="Customer Service Request"
                      decoding="async"
                      sizes="(max-width: 28px) 100vw, 28px"
                    />

                    <a
                      href="/locate/contact-us"
                      id="footerCustomerServiceRequest"
                      className="footerdealerlocator text-link"
                    >
                      Customer Service Request
                    </a>
                    <p>Got a grievance or a complaint? We are happy to help.</p>
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="footer-information">
                    <img
                      width="28"
                      height="28"
                      src={catalogueIcon}
                      alt="Download Catalogue"
                      decoding="async"
                      sizes="(max-width: 28px) 100vw, 28px"
                    />
                    <a
                      href="/catalogue"
                      id="footerDownloadCatalogue"
                      className="footerdealerlocator text-link"
                    >
                      Download Catalogue
                    </a>
                    <p>
                      Find all product-related specifications, product listing
                      and other information in the Johnson Bathrooms catalogue
                    </p>
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="footer-information">
                    <img
                      width="28"
                      height="22"
                      src={talkexpertIcon}
                      alt="Talk to an Expert"
                      decoding="async"
                      sizes="(max-width: 28px) 100vw, 28px"
                    />

                    <a
                      href="/locate/contact-us"
                      id="footerScheduleStoreVisit"
                      className="footerdealerlocator text-link"
                    >
                      Talk to an Expert
                    </a>
                    <p>
                      We are here to solve all your sanitaryware related queries
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </LazyLoadComponent>
  );
};

export default CustomerService;
